import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { EventHubsLinkedService } from 'shell-models-lib';
import { IModel } from '../../base/annotation';
import { ValueAdapter } from '../value.adapter';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EventHubsLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                namespaceName: '*',
                accessKeyname: '*',
                accessKey: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class EventHubsLinkedServiceAdapter extends LinkedServiceAdapter<EventHubsLinkedService> {

    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => EventHubsLinkedService {
        return EventHubsLinkedService;
    }

    protected model(): IModel {
        return EventHubsLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: EventHubsLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {

        const properties = this.properties(linkedServiceResource) as Model.EventHubsLinkedService;
        properties.type = Metamodel.modelFor(EventHubsLinkedService).name;

        properties.typeProperties = {
            namespaceName: this.valueToResource(linkedService, EventHubsLinkedService.NAMESPACE_NAME),
            accessKeyName: this.valueToResource(linkedService, EventHubsLinkedService.ACCESS_KEY_NAME),
            accessKey: parameterizablePasswordOrAKVtoSecretBase(linkedService, EventHubsLinkedService.ACCESS_KEY, this.context),
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: EventHubsLinkedService): Promise<EventHubsLinkedService> {

        const properties = linkedServiceResource.properties as Model.EventHubsLinkedService;
        const typeProperties = properties.typeProperties;

        ValueAdapter.toModel(linkedService, EventHubsLinkedService.NAMESPACE_NAME, typeProperties.namespaceName);
        ValueAdapter.toModel(linkedService, EventHubsLinkedService.ACCESS_KEY_NAME, typeProperties.accessKeyName);
        parameterizableSecretBaseToModel(linkedService, EventHubsLinkedService.ACCESS_KEY, typeProperties.accessKey, this.context);
        return linkedService;
    }
}
